import { styled } from 'styled-components';

export const WizardTab = styled.div`
  border: 1px solid ${({ theme }) => theme.colours.canvas.secondary.main};
  border-radius: ${({ theme }) => theme.borderRadius.secondary};
  margin-bottom: ${({ theme }) => theme.sizing.medium};
`;

export const WizardTabHeader = styled.div`
  ${({ theme }) => theme.typography.bodyRegular}
  line-height: 1;
  padding: ${({ theme }) => theme.sizing.medium};
  background: ${({ theme, selected }) =>
    selected
      ? theme.colours.canvas.secondary.main
      : theme.colours.canvas.tertiary.main};
  border-color: ${({ theme }) => theme.colours.canvas.secondary.main};
  color: ${({ theme }) => theme.colours.ink.primary.main};
  border-radius: ${({ theme, $isOpen }) =>
    $isOpen
      ? `${theme.borderRadius.secondary} ${theme.borderRadius.secondary} 0 0`
      : theme.borderRadius.secondary};
  border-width: ${({ $isOpen }) => ($isOpen ? '0 0 1px 0' : 0)};

  &:hover {
    cursor: pointer;
    background: ${({ theme, selected }) =>
      selected
        ? theme.colours.canvas.secondary.strong
        : theme.colours.canvas.tertiary.strong};
  }

  span + span {
    ${({ theme }) => theme.typography.headingMedium}
    color: ${({ theme }) => theme.colours.ink.primary.main};
    display: inline-flex;
    gap: ${({ theme }) => theme.sizing.medium};
    float: right;
    line-height: 1;
    transition: transform ${({ theme }) => theme.animation.duration.default}
      ${({ theme }) => theme.animation.easing.moving};

    &.open {
      transform: rotate(180deg);
    }

    svg {
      position: relative;
      top: -1px;
    }
  }
`;

export const WizardSelected = styled.span`
  padding: 0 ${({ theme }) => theme.sizing.medium} 0 0;
`;

export const WizardTabBody = styled.div`
  overflow: hidden;
  border-left: 4px solid ${({ theme }) => theme.colours.interface.main};
  border-radius: ${({ theme }) => `0 0 0 ${theme.borderRadius.secondary}`};
  display: flex;
  gap: ${({ theme }) => theme.sizing.medium};
  transition:
    min-height ${({ theme }) => theme.animation.duration.slow}
      ${({ theme }) => theme.animation.easing.moving},
    max-height ${({ theme }) => theme.animation.duration.slow}
      ${({ theme }) => theme.animation.easing.moving};
  border-width: 0 0 0 4px;

  ${({ $isExpanded }) => `
    min-height: ${$isExpanded ? '40px' : '0'};
    max-height: ${$isExpanded ? '550px' : '0'};
  `}

  > div {
    width: 100%;
    padding: ${({ theme }) => theme.sizing.medium};
    overflow-y: scroll;
    overflow-x: hidden;
  }
`;
